import React, { FC } from 'react'

import { InlineSwitch } from '@new/__global/components/Filters/FiltersVariations/InlineSwitch'

import { FiltersSharedProps } from './Filters.types'

interface StabilizedOnlyProps extends FiltersSharedProps {
  initialValue?: boolean
  onChange: (value?: boolean) => void
}

export const StabilizedOnly: FC<StabilizedOnlyProps> = ({ initialValue, onChange, label }) => (
  <InlineSwitch
    title={label || 'Stabilized Only'}
    initialValue={initialValue}
    onChange={onChange}
  />
)
